module.exports = __webpack_public_path__ + "static/media/Volvo.63889136.jpeg";